import { AdDetails } from '@/api/types/ads.types';
import { AdContactInfoEnum, Shop } from '@/api/types/common.types';

export function getVisibleShop(adData?: AdDetails | null): Shop | null {
  const shop = adData?.shop ?? null;
  if (!shop) return null;

  const features = adData?.features;
  const adFeatures = features?.adFeatures;
  const shopFeatures = features?.shopFeatures ?? shop?.features;
  const shouldShowUserContact =
    adFeatures?.contactInfoType === AdContactInfoEnum.User;
  const isShopPageDisabled = shopFeatures?.shopPageEnabled === false;

  if (shouldShowUserContact || isShopPageDisabled) return null;
  return shop;
}
